module.exports = "/_next/static/images/6e9f70bcebb87e3d9524657c39ab8856-nubanker-eng@1x.jpg.webp";